/**
 * =====================================================
 * Signature store
 * =====================================================
 *
 * Handles signature states and behavior of the acknowledge receipt
 *
 * =====================================================
 */
export default {
  namespaced: true,
  strict: process.env.APP_ENV === 'development',
  state () {
    return {
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'transparent'
      },
      isSignatureBoardOpen: false,
      disableSignatureBoardSubmitButton: false,
      signature: '',
      selectedORID: 0,
      isORModalOpen: false,
      acknowledge_receipt_image: '',
      acknowledge_receipt_status: ''
    }
  },
  mutations: {
    /**
     * Set close/open the signature board.
     *
     * @param state
     * @param status
     */
    setSignatureBoard (state, status) {
      state.isSignatureBoardOpen = status
    },

    /**
     * Set the signature sign.
     *
     * @param state
     * @param signature
     */
    setSignature (state, signature) {
      state.signature = signature
    },

    /**
     * Set Disable signature board submit button.
     *
     * @param state
     * @param status
     */
    setDisableSignatureBoardSubmitButton (state, status) {
      state.disableSignatureBoardSubmitButton = status
    },

    /**
     * Set OR ID.
     *
     * @param state
     * @param id
     */
    setORID (state, id) {
      state.selectedORID = id
    },

    /**
     * Set OR Modal open.
     *
     * @param state
     * @param status
     */
    setORModalOpen (state, status) {
      state.isORModalOpen = status
    },

    /**
     * Set Acknowledge Receipt Image.
     *
     * @param state
     * @param receipt
     */
    setAcknowledgeReceiptImage (state, receipt) {
      state.acknowledge_receipt_image = receipt
    },

    /**
     * Set Acknowledge Receipt Status.
     *
     * @param state
     * @param status
     */
    setAcknowledgeReceiptStatus (state, status) {
      state.acknowledge_receipt_status = status
    }
  },
  actions: {
    /**
     * Show Signature Board.
     *
     * @param {commit} commit
     */
    showSignatureBoard ({ commit }) {
      commit('setSignatureBoard', true)
    },

    /**
     * Hide Signature Board.
     *
     * @param {commit} commit
     */
    hideSignatureBoard ({ commit }) {
      commit('setSignatureBoard', false)
    },

    /**
     * Show signature.
     *
     * @param {commit} commit
     * @param signature
     */
    showSignature ({ commit }, signature) {
      commit('setSignature', signature)
    },

    /**
     * Set disable signture board submit button.
     *
     * @param {commit} commit
     * @param status
     */
    setDisableSignatureBoardSubmitButton  ({ commit }, status) {
      commit('setDisableSignatureBoardSubmitButton', status)
    },

    /**
     * Set OR ID.
     *
     * @param {commit} commit
     * @param status
     */
    setORID ({ commit }, id) {
      commit('setORID', id)
    },

    /**
     * Set OR modal OPen.
     *
     * @param {commit} commit
     * @param status
     */
    setORModalOpen ({ commit }, status) {
      commit('setORModalOpen', status)
    },

    /**
     * Set Acknowledge Receipt Image.
     *
     * @param {commit} commit
     * @param receipt
     */
    setAcknowledgeReceiptImage ({ commit }, receipt) {
      commit('setAcknowledgeReceiptImage', receipt)
    },

    /**
     * Set Acknowledge Receipt Status.
     *
     * @param {commit} commit
     * @param status
     */
    setAcknowledgeReceiptStatus ({ commit }, status) {
      commit('setAcknowledgeReceiptStatus', status)
    }
  }
}
